"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
let EditSortNumberDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.ids = [];
    this.sortWay = "INCREASING";
    this.sortStartNumber = 0;
  }
  open(ids) {
    this.ids = ids;
    this._edit_sort_number_dialog.show();
  }
  sortWayChange() {
    if (this.sortWay === "INCREASING") {
      this.sortStartNumber = 0;
    }
    if (this.sortWay === "DECREASING") {
      this.sortStartNumber = this.ids.length;
    }
    if (this.sortWay === "FIXED") {
      this.sortStartNumber = 0;
    }
  }
  sortNumberTips() {
    if (this.sortWay === "INCREASING") {
      return `${this.sortStartNumber},${this.sortStartNumber + 1},${this.sortStartNumber + 2},...`;
    }
    if (this.sortWay === "DECREASING") {
      return `${this.sortStartNumber},${this.sortStartNumber - 1},${this.sortStartNumber - 2},...`;
    }
    if (this.sortWay === "FIXED") {
      return `${this.sortStartNumber},${this.sortStartNumber},${this.sortStartNumber},...`;
    }
  }
  confirm() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth.pro/v1/user_shop_sort`, __spreadValues({
          "shopIds": this.ids,
          "model": this.sortWay
        }, (() => {
          if (this.sortWay === "INCREASING" || this.sortWay === "DECREASING") {
            return {
              "sortStartValue": this.sortStartNumber
            };
          } else if (this.sortWay === "FIXED") {
            return {
              "sortValue": this.sortStartNumber
            };
          } else {
            return {};
          }
        })()));
        this.$message.success(this.$t("edit_sort_number_dialog.success_message"));
        this.close();
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  cancel() {
    this.close();
  }
  close() {
    this._edit_sort_number_dialog.hide();
    this.ids = [];
    this.sortWay = "INCREASING";
    this.sortStartNumber = 0;
  }
};
__decorateClass([
  Ref("edit-sort-number-dialog")
], EditSortNumberDialog.prototype, "_edit_sort_number_dialog", 2);
EditSortNumberDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], EditSortNumberDialog);
export {
  EditSortNumberDialog as default
};
